import { Flex, Text } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { Tooltip } from 'src/design-system/Tooltip';

type Props = {
  label: string;
  onClick: () => void;
  tooltip?: string;
};

export function SelectedClientPill({ label, onClick, tooltip }: Props) {
  const pill = (
    <Flex
      align="center"
      gap={12}
      pl={20}
      pr={20}
      py="xs"
      bg="gray.0"
      style={{
        borderRadius: 20,
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10">
        {label}
      </Text>
      <IconX size={20} color="var(--mantine-color-gray-10)" style={{ flexShrink: 0 }} />
    </Flex>
  );

  if (!tooltip) return pill;

  return (
    <Tooltip label={tooltip} position="bottom">
      {pill}
    </Tooltip>
  );
}
